/** biome-ignore-all lint/style/noRestrictedImports: date-fns imports are allowed in @cobliteam/utils only. All other packages must import from @cobliteam/utils/date. */
import { parseISO } from 'date-fns';
import type { DateValue } from './types';

export function toDate(value: DateValue): Date {
  if (value instanceof Date) return value;
  if (typeof value === 'number') return new Date(value);
  if (typeof value === 'string') return parseISO(value);
  return value as Date;
}
